<template>
  <div class="fy-input-dev">
    <input
      :placeholder="placeholder"
      :readonly="readonly"
      :type="type"
      @blur="handleBlur"
      @change="handleChange"
      @focus="handleFocus"
      @input="handleInput"
      class="fy-input"
      ref="input"
      v-if="type !== 'textarea'"
      v-model="currentValue"
    >

    <textarea
      :placeholder="placeholder"
      :readonly="readonly"
      :value="currentValue"
      @blur="handleBlur"
      @change="handleChange"
      @focus="handleFocus"
      @input="handleInput"
      class="fy-input"
      v-else
    />
    <slot></slot>
  </div>
</template>
<script>
import util from '../utils/util.js'
export default {
  name: 'FyInput',

  componentName: 'FyInput',
  mixins: [util], //这些混入实例对象可以像正常的实例对象一样包含选项（可以直接this.*使用混入对象中的方法）

  inject: {
    fyForm: {
      default: ''
    },
    fyFormItem: {
      default: ''
    }
  },
  data () {
    return {
      currentValue:
        this.value === undefined || this.value === null
          ? ''
          : this.value,
      is_yet_click: false,  //由于ie浏览器中设置placeholder属性会自动触发input事件，会导致自动验证，加一个参数判断是否为刚进入页面
    }
  },
  props: {
    value: [String, Number],
    type: {
      type: String,
      default: 'text'
    },
    placeholder: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
  },
  watch: {
    //在input子组件中不能直接改变在外部双向绑定的value
    value (value) {
      this.setCurrentValue(value)
    },
    currentValue (value) {
      this.$emit('input', value) // 触发 input 事件
    }
  },
  mounted () {
    this.dispatch('FyFormItem', 'formItem.addChildVc', [this]) //发送添加formitem对象的信息
  },
  methods: {
    resetField () {
      this.$emit('input', '')
    },
    setCurrentValue (value) {
      if (value === this.currentValue) return // 如果新旧值一致直接返回
      this.currentValue = value // 改变当前值
    },
    handleFocus (event) {
      // console.log('>>>handleFocus')
      this.is_yet_click = true  //触发focus事件时设置为true
      const value = event.target.value
      this.dispatch('FyFormItem', 'el.form.focus', [value])
    },
    //TODO xsw ie浏览器中获得焦点和失去焦点时都会触发handleInput
    //所以总结一下就是，在IE10/11中，设置placeholder属性的时候会触发“input”事件
    //解决:
    //  1.在设置placeholder属性之后才绑定Input事件，如下(这里不适用，没有使用)
    //  2.设置一个参数判断是否为刚进入页面，在用户触发focus事件时设置为true
    handleInput (event) {
      // const value = event.target.value
      if (this.is_yet_click) {  //由于ie浏览器中设置placeholder属性会自动触发input事件，会导致自动验证，加一个参数判断是否为刚进入页面
        const value = event.target.value
        this.$emit('input', value) //同步改变父组件中双向绑定的值
        this.dispatch('FyFormItem', 'el.form.change', [value])
      }
    },
    handleChange (event) {
      // console.log('>>>handleChange')
      const value = event.target.value
      this.$emit('change', value)
    },
    handleBlur (event) {
      const value = event.target.value
      this.dispatch('FyFormItem', 'el.form.blur', [value])
    }
  }
}
</script>
<style scoped>
@import '../../assets/css/components/form/form.css';
</style>



// WEBPACK FOOTER //
// src/components/form/input.vue